var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.lookImage}},[_c('vue-markdown',{ref:'markdown'+ _vm.msgId,staticClass:"mark_down",attrs:{"source":_vm.typedContent}}),(_vm.showPreview)?_c('div',[_c('img-view',{attrs:{"url-list":_vm.imgList},on:{"closeViewer":_vm.closeViewer}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }